import {
  transition,
  trigger,
  query,
  style,
  animate,
  group,
  animateChild,
} from '@angular/animations';

export const slideInAnimation = trigger('routeAnimations', [
  transition('Intro => Authentication1', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Authentication1 => Authentication2', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Authentication2 => Authentication1', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '100' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Authentication1 => TermofUse', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('TermofUse  => Authentication1', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '100' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Authentication2 => Register', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Register => Authentication2', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '100' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Register => Promotion', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Promotion => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Promotion => Shop', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Shop => Promotion', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => MainExercise', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('MainExercise => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('MainExercise => newExercise', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('newExercise => MainExercise', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Authentication2 => DietType', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('DietType => Authentication2', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('DietType => DietPersonalType', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('DietPersonalType => DietType', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '100' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => DietType', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('DietType => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('DietType => Generate', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Generate => DietType', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('DietPersonalType => Generate', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Generate => DietPersonalType', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('DietTypeOverview => DietPersonalType', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('DietPersonalType => DietTypeOverview', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('DietTypeOverview => Generate', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Generate => DietTypeOverview', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Generate => GenerateOverview', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  // transition('GenerateOverview => ', [
  //     query(':enter, :leave', style({ position: 'fixed', width: '100%', height: '100vh' }), { optional: true }),
  //     group([
  //         query(':enter', [
  //             style({ transform: 'translateX(0%)' }),
  //         ], { optional: true }),
  //         query(':leave', [
  //             style({ transform: 'translateX(0%)', zIndex: '1000' }),
  //             animate('0.5s ease-in-out', style({ transform: 'translateX(-100%)' }))
  //         ], { optional: true }),
  //     ])
  // ]),
  transition('Main => CheatDay', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('CheatDay => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('CheatDay => Shop', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Shop => CheatDay', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => Profile', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Profile => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  // transition('Post => Profile', [
  //   query(
  //     ':enter, :leave',
  //     style({ position: 'fixed', width: '100%', height: '100vh' }),
  //     { optional: true }
  //   ),
  //   group([
  //     query(
  //       ':enter',
  //       [
  //         style({ transform: 'translateX(-100%)', zIndex: '1000' }),
  //         animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
  //       ],
  //       { optional: true }
  //     ),
  //     query(':leave', [style({ transform: 'translateX(0%)' })], {
  //       optional: true,
  //     }),
  //   ]),
  // ]),
  // transition('Profile => Post', [
  //   query(
  //     ':enter, :leave',
  //     style({ position: 'fixed', width: '100%', height: '100vh' }),
  //     { optional: true }
  //   ),
  //   group([
  //     query(':enter', [style({ transform: 'translateX(0%)' })], {
  //       optional: true,
  //     }),
  //     query(
  //       ':leave',
  //       [
  //         style({ transform: 'translateX(0%)', zIndex: '1000' }),
  //         animate(
  //           '0.5s ease-in-out',
  //           style({ transform: 'translateX(-100%)' })
  //         ),
  //       ],
  //       { optional: true }
  //     ),
  //   ]),
  // ]),
  transition('Main => TribuneSearch', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('TribuneSearch => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('TribuneSearch => TribuneTags', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('TribuneTags => TribuneSearch', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('TribuneSearch => Profile', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Profile => TribuneSearch', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Profile => ProfileEdit', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('ProfileEdit => Profile', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => TribuneActivity', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('TribuneActivity => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('TribuneActivity => Profile', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Profile => TribuneActivity', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('TribuneActivity => Post', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Post => TribuneActivity', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('* => TribuneFolloweese', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('TribuneFolloweese => *', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('TribuneSearch => TribuneTags', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('TribuneTags => TribuneSearch', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Post => TribuneTags', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('TribuneTags => Post', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('TribuneTags => Post', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Post => TribuneTags', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('* => TribuneSuggest', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('TribuneSuggest => *', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('* => TribuneNewPost', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('TribuneNewPost => *', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Profile => Post', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Post => Profile', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => Post', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Post => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => PlanOverview', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('PlanOverview => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('PlanOverview => DietType', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('DietType => PlanOverview', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('PlanOverview => Shop', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Shop => PlanOverview', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('PlanOverview => CheatDay', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('CheatDay => PlanOverview', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => ChangeMeal', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('ChangeMeal => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => MealDetail', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('MealDetail => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('MealDetail => DietType', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('DietType => MealDetail', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('MealDetail => Shop', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Shop => MealDetail', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('MealDetail => CheatDay', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('CheatDay => MealDetail', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => DailyFoodFact', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('DailyFoodFact => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('MealDetail => ChangeMeal', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('ChangeMeal => MealDetail', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('MealDetail => AddFood', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('AddFood => MealDetail', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => DietDetail', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('DietDetail => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => DietTypeOverview', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('DietTypeOverview => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => ProfileWaterChart', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('ProfileWaterChart => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => ProfileWeightChart', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('ProfileWeightChart => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => RecipeCategory', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('RecipeCategory => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => RecipeDetail', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('RecipeDetail => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => BookmarkedRecipes', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('BookmarkedRecipes => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('RecipeCategory => RecipeDetail', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('RecipeDetail => RecipeCategory', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => Setting', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Setting => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => Referral', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Referral => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Support => AboutUs', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateY(100%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('AboutUs => Support', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateY(0%)', zIndex: '100' }),
          animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' })),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Setting => Support', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Support => Setting', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Support => MessageInbox', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('MessageInbox =>  Support', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('MessageInbox => MessagePage', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('MessagePage => MessageInbox', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('FAQ => AnswerFAQ', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('AnswerFAQ => FAQ', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Support => FAQ', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('FAQ => Support', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Support => ReportProblem', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('ReportProblem => Support', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Setting => PersonalInfo', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('PersonalInfo => Setting', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Setting => TribuneSetting', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('TribuneSetting => Setting', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('Main => Shop', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('Shop => Main', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('MealDetail => personals', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('personals => MealDetail', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('personals => AddFood', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('AddFood => personals', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('personals => personalFood', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('personalFood => personals', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('personalFood => createpersonalFood', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('createpersonalFood => personalFood', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('personals => personalPackage', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('personalPackage => personals', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
  transition('personalPackage => createpersonalPackage', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)', zIndex: '1000' }),
          animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true }
      ),
      query(':leave', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
    ]),
  ]),
  transition('createpersonalPackage => personalPackage', [
    query(
      ':enter, :leave',
      style({ position: 'fixed', width: '100%', height: '100vh' }),
      { optional: true }
    ),
    group([
      query(':enter', [style({ transform: 'translateX(0%)' })], {
        optional: true,
      }),
      query(
        ':leave',
        [
          style({ transform: 'translateX(0%)', zIndex: '1000' }),
          animate(
            '0.5s ease-in-out',
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
  ]),
]);
